import { getInstance } from '@/plugins/gAuth';

const gAuthGuard = (to, from, next) => { // beforeEnter hook
  const authService = getInstance();

  const fn = async () => {
    if (authService.googleSignedIn) {
      if (to.path === '/callback') {
        return next('/django-login');
      }
    }
    if (authService.isSignedIn) {
      return next();
    }
    if (to.path !== '/login') {
      await authService.signIn();
      return next();
    }
    return next();
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch('loading', (loading) => {
    if (loading === false) {
      return fn();
    }
  });
};

export default gAuthGuard;
